import { render, staticRenderFns } from "./inventoryStat_v2.vue?vue&type=template&id=6390495a&scoped=true&"
import script from "./inventoryStat_v2.vue?vue&type=script&lang=js&"
export * from "./inventoryStat_v2.vue?vue&type=script&lang=js&"
import style0 from "./inventoryStat_v2.vue?vue&type=style&index=0&id=6390495a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6390495a",
  null
  
)

component.options.__file = "inventoryStat_v2.vue"
export default component.exports